module.exports = __webpack_public_path__ + "static/media/onboarding_mission.ffb43522.png";